import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerAdminServiceWorker } from "@/lib/adminPwa";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for /admin routes (PWA)
if (typeof window !== "undefined") {
  window.addEventListener("load", () => {
    registerAdminServiceWorker();
  });
}
